<template>
  <div class="footer-warpper">Copyright 2021 ©三间有暖平台.All rights reserved.</div>
</template>

<script>
export default {
  name: "footer-modular",
}
</script>

<style scoped lang="scss">
.footer-warpper{
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #808080;
  background: #efedee;
}
</style>
